import { render, staticRenderFns } from "./edu_index.vue?vue&type=template&id=fc332434&"
import script from "./edu_index.vue?vue&type=script&lang=js&"
export * from "./edu_index.vue?vue&type=script&lang=js&"
import style0 from "./edu_index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports